module.exports = __webpack_public_path__ + "img/MU.76dc2cdd.svg";